import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TimeframeFooter } from "./TimeframeFooter";
import { ShortcutHelpModal } from "../ShortcutHelpModal";
/**
 * BL-03B extraction from VNInvestCharts.tsx (behavior-identical move).
 * Footer with timeframe/range/scale controls + bottom-tab toggles.
 */
export function ChartFooter({ showFooter, renderFooter, timeframe, localRange, onTimeframeChange, onRangeChange, scaleMode, onScaleModeChange, timezone, t, activeBottomTab, onBottomTabChange, }) {
    // UI-AUDIT: the shortcut modal must stay mounted even with the footer
    // hidden so `?` keeps working. The inline `? Phím tắt` chip is hidden by default
    // (it repeated on every cell in multicharts); `?` is still the way in.
    if (!showFooter)
        return _jsx(ShortcutHelpModal, { hintInline: true });
    if (renderFooter) {
        return _jsx(_Fragment, { children: renderFooter({ timeframe, range: localRange }) });
    }
    const tabButton = (tab, label) => (_jsx("button", { onClick: () => onBottomTabChange(activeBottomTab === tab ? null : tab), style: {
            padding: "3px 8px",
            background: activeBottomTab === tab ? "var(--vnsc-accent-strong, #2563eb)" : "transparent",
            border: "none",
            borderRadius: "4px",
            color: activeBottomTab === tab ? "#fff" : "var(--vnsc-text-secondary, #a0a0a0)",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: 600,
        }, children: label }));
    return (_jsxs(TimeframeFooter, { timeframe: timeframe, onTimeframeChange: onTimeframeChange, range: localRange, onRangeChange: onRangeChange, scaleMode: scaleMode, onScaleModeChange: onScaleModeChange, timezone: timezone, trailingNode: _jsx(ShortcutHelpModal, { hintInline: true }), children: [tabButton("pine_editor", t("ui.bottomTab.pineEditor") || "Pine Editor"), tabButton("strategy_tester", t("ui.bottomTab.strategyTester") || "Strategy Tester"), tabButton("paper_trade", t("ui.bottomTab.paperTrading") || "Paper Trading"), activeBottomTab && (_jsx("button", { onClick: () => onBottomTabChange(null), title: t("common.close") || "Close", "aria-label": t("common.close") || "Close", style: {
                    background: "transparent",
                    border: "none",
                    color: "var(--vnsc-text-secondary, #a0a0a0)",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    fontSize: "11px",
                    marginLeft: "4px",
                    padding: "2px",
                }, children: _jsxs("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: [_jsx("line", { x1: "1", y1: "1", x2: "9", y2: "9" }), _jsx("line", { x1: "9", y1: "1", x2: "1", y2: "9" })] }) }))] }));
}
